import { render } from "./publish-scan.vue?vue&type=template&id=5dc991ba&ts=true&lang=pug"
import script from "./publish-scan.vue?vue&type=script&lang=ts"
export * from "./publish-scan.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__